import { NgModule } from '@angular/core';

// Other Modules
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AgmCoreModule } from '@agm/core';

// PrimeNG Material
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { DataViewModule } from 'primeng/dataview';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ListboxModule } from 'primeng/listbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { GalleriaModule } from 'primeng/galleria';

const components = [
  ClipboardModule,
  NgbModule,
  CarouselModule,
  AutocompleteLibModule,
  AgmCoreModule,

  DialogModule,
  ButtonModule,
  SelectButtonModule,
  DynamicDialogModule,
  DataViewModule,
  PanelModule,
  TableModule,
  PaginatorModule,
  InputSwitchModule,
  ToastModule,
  TooltipModule,
  ConfirmDialogModule,
  KeyFilterModule,
  ListboxModule,
  RadioButtonModule,
  CheckboxModule,
  GalleriaModule,
];

@NgModule({
  declarations: [],
  imports: [components],
  exports: [components],
})
export class MaterialModule {}
